import React from "react";

/**
 * UpgradeToCMOBanner - Displays upgrade CTA for non-CMO SERVICE users
 * Shows features available on CMO SERVICE tier and upgrade button
 */
export default function UpgradeToCMOBanner({ isDarkMode = false, onUpgradeClick = null }) {
  const features = [
    "Schedule posts to 28+ social platforms",
    "Auto-publish at optimal times for each platform",
    "Track analytics and engagement metrics",
    "Manage multiple social accounts",
    "AI-powered content recommendations",
  ];

  return (
    <div className="flex-1 flex items-center justify-center p-4 md:p-8">
      <div className={`w-full max-w-2xl ${isDarkMode ? 'bg-gray-800' : 'bg-gray-50'} rounded-xl p-6 md:p-8 border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} shadow-lg`}>
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-3xl">🚀</span>
            <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Performance Marketing</h2>
          </div>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Unlock powerful social media management tools with our IGR Creatives tier
          </p>
        </div>

        {/* Features List */}
        <div className="mb-6 space-y-2.5">
          {features.map((feature, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <span className="text-green-500 font-bold text-lg flex-shrink-0">✓</span>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{feature}</p>
            </div>
          ))}
        </div>

        {/* Current Plan Info */}
        <div className={`p-4 rounded-lg mb-6 ${isDarkMode ? 'bg-gray-700/50' : 'bg-gray-100'} border ${isDarkMode ? 'border-gray-600' : 'border-gray-300'}`}>
          <p className={`text-xs mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            <span className="font-semibold">Current Plan:</span> You're on a Free or Basic plan
          </p>
          <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Upgrade to IGR Creatives to access all Performance Marketing features and unlock 5x your social media potential.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 mb-4">
          <button
            onClick={onUpgradeClick}
            className={`flex-1 px-4 py-3 rounded-lg font-semibold text-sm transition whitespace-nowrap ${
              isDarkMode
                ? 'bg-cyan-600 text-white hover:bg-cyan-700'
                : 'bg-cyan-500 text-white hover:bg-cyan-600'
            }`}
          >
            Upgrade to IGR Creatives
          </button>
          <button
            onClick={() => window.open('https://docs.infinium.com/cmo-service', '_blank')}
            className={`flex-1 px-4 py-3 rounded-lg font-semibold text-sm transition whitespace-nowrap border-2 ${
              isDarkMode
                ? 'border-gray-600 text-gray-300 hover:bg-gray-700'
                : 'border-gray-300 text-gray-700 hover:bg-gray-100'
            }`}
          >
            Learn More
          </button>
        </div>

        {/* Overlay Indicator */}
        <div className={`p-3 rounded-lg text-center ${isDarkMode ? 'bg-gray-700/30' : 'bg-gray-100'} border ${isDarkMode ? 'border-gray-600/50' : 'border-gray-200'}`}>
          <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            ℹ️ Performance Marketing is available on the <span className="font-semibold">IGR Creatives</span> tier and above
          </p>
        </div>
      </div>
    </div>
  );
}
